import React from "react"
import Responsive from "react-responsive"

import TTbullets from "./TTbullets"

const Desktop = props => <Responsive {...props} minWidth={1000} />
const Mobile = props => <Responsive {...props} maxWidth={999} />

const TransactionsTrend = () => {
  const hrefSymbol = "#"

  return (
    <section className="transactionsTrend">
      <div className="transactionsTrend-UI">
        <Desktop>
          <img
            className="transactionsTrend-image"
            src="/images/Section3/transactions-trend-desktop.svg"
            alt="Transactions trend desktop"
          />
        </Desktop>
        <Mobile>
          <img
            className="transactionsTrend-image"
            src="/images/Section3/transactions-trend-mobile.svg"
            alt="Transactions trend mobile"
          />
        </Mobile>
        <h1 className="transactionsTrend-UI-title">Transactions Trend</h1>
      </div>

      <div className="transactionsTrend-info">
        <h3 className="transactionsTrend-info-title">
          View all your transactions <span>in one app</span>
        </h3>
        <TTbullets />
        <a href={hrefSymbol} className="transactionsTrend-info-learnMore">
          Learn more >
        </a>
      </div>
    </section>
  )
}

export default TransactionsTrend
